import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { SmartApp, AuthCallback, Login, Logout, ResetPwd, SignOut, SSOCallback, ContentView, NewsAttachment, PreTripAttachment, TripProposalAttachment, Setting } from './pages';
import { ProtectedRoute, ErrorBoundary } from '~/components';
import { createStore, applyMiddleware } from 'redux'
import { rootReducer, rootSaga } from './redux';
import createSagaMiddleware from 'redux-saga';
import './index.less';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { getIEVersion, isEmpty } from '~/common';
import { addLocaleData, IntlProvider } from 'react-intl';
import appLocale, { initBodyFontClass } from '~/locales';
import ConfigProviderPolyfill from '~/components/ConfigProviderPolyfill';
import { WithConfigRequired } from './components';

const sagaMiddleWare = createSagaMiddleware();

export const store = createStore(rootReducer, applyMiddleware(sagaMiddleWare));
store.subscribe(() => {
    //console.log(store.getState());
});
sagaMiddleWare.run(rootSaga);

addLocaleData(appLocale.data);

initBodyFontClass();

const AppWithConfig = ({ config, auth }) => {

    return <ErrorBoundary>
        <BrowserRouter basename={config.publicUrl}>
            <Switch>
                <Route path='/admin/setting' exact render={props => <Setting auth={auth} {...props} />} />
                <Route path='/login' exact render={props => <Login auth={auth} {...props} />} />
                <Route path='/logout' exact render={props => <Logout auth={auth} {...props} />} />
                <Route path='/callback' exact render={props => <AuthCallback auth={auth} {...props} />} />
                <Route path='/sign-out' exact render={props => <SignOut auth={auth} {...props} />} />
                {!isEmpty(config.resetPasswordRoute) && <Route path={config.resetPasswordRoute} exact render={props => <ResetPwd auth={auth}  {...props} />} />}
                <Route path='/auth/sso/:code' exact render={props => <SSOCallback auth={auth} {...props} />} />
                <Route path='/sso/:code' exact render={props => <SSOCallback auth={auth} {...props} />} />
                <Route path='/privacy-agreement' exact render={props => <ContentView category='Terms' keyword='privacy-agreement' {...props} />} />
                <ProtectedRoute path='/attachment/news' exact auth={auth} component={NewsAttachment} />
                <ProtectedRoute path='/pre-trip/attachment' exact auth={auth} component={PreTripAttachment} />
                <ProtectedRoute path='/booking/attachment' exact auth={auth} component={TripProposalAttachment} />
                <ProtectedRoute path='/' auth={auth} component={SmartApp} />
            </Switch>
        </BrowserRouter>
    </ErrorBoundary>;
}

const App = () => {
    const ieVersion = getIEVersion();
    if (ieVersion > 0 && ieVersion < 11) return null;

    return (
        <IntlProvider locale={appLocale.locale} key={appLocale.locale} messages={appLocale.messages}>
            <Provider store={store}>
                <WithConfigRequired render={props => <AppWithConfig {...props} />} />
            </Provider>
        </IntlProvider>
    );
};

ReactDOM.render(
    <ConfigProviderPolyfill locale={appLocale.antd} component={App} />,
    document.getElementById('ctm-smart-app')
);